import { render, staticRenderFns } from "./ServiceProfile.vue?vue&type=template&id=ffa9b30e&scoped=true&"
import script from "./ServiceProfile.vue?vue&type=script&lang=js&"
export * from "./ServiceProfile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProfile.vue?vue&type=style&index=0&id=ffa9b30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa9b30e",
  null
  
)

export default component.exports